import { DOCUMENT_TYPE } from "../../Constants"
import { InvoiceDto } from "../../invoice/models"
import { OrderDto } from "../../order/Order"
import { QuoteDto } from "../../quote/Quote"
import { TaxDto } from "../../tax/Tax"
import { GroupDto } from "../Group"
import { PricingFeeCalculationDto } from "../PricingFeeCalculation"
import PricingRow, { PricingRowDto } from "../PricingRow"
import { PricingTotalDto } from "../PricingTotals"
import { PricingTable } from "../models"
import { PatchRowPayload } from "../row/services"
import { CreateGroupPayload, PatchPayload, RowReferencePayload } from "../services"

export const ACTION_TYPES = {
    PATCH_PRICING_TABLE: "PATCH_PRICING_TABLE" as const,
    PATCH_PRICING_TABLE_SUCCESS: "PATCH_PRICING_TABLE_SUCCESS" as const,
    PATCH_PRICING_TABLE_PENDING: "PATCH_PRICING_TABLE_PENDING" as const,
    PATCH_PRICING_TABLE_ITEM: "PATCH_PRICING_TABLE_ITEM" as const,
    PATCH_PRICING_TABLE_ITEM_SUCCESS: "PATCH_PRICING_TABLE_ITEM_SUCCESS" as const,
    CREATE_GROUP: "CREATE_PRICING_TABLE_GROUP" as const,
    CREATE_PRICING_TABLE_GROUP_SUCCESS: "CREATE_PRICING_TABLE_GROUP_SUCCESS" as const,
    DELETE_PRICING_TABLE_ITEM: "DELETE_PRICING_TABLE_ITEM" as const,
    DELETE_PRICING_TABLE_ITEM_SUCCESS: "DELETE_PRICING_TABLE_ITEM_SUCCESS" as const,
    SET_INITIAL_VALUES:"SET_INITIAL_VALUES" as const,
    SET_PRICING_TABLE: "SET_PRICING_TABLE" as const,
    SET_PRICING_TABLE_ID: "SET_PRICING_TABLE_ID" as const,
    SET_PRICING_TABLE_TOTALS: "SET_PRICING_TABLE_TOTALS" as const,
    SET_PRICING_TABLE_TAXES: "SET_PRICING_TABLE_TAXES" as const,
    SET_PRICING_TABLE_GROUP_ITEMS: "SET_PRICING_TABLE_GROUP_ITEMS" as const,
    SET_PRICING_TABLE_FEES: "SET_PRICING_TABLE_FEES" as const,
    PRICING_TABLE_SELECTED_ITEMS_ADD_ITEM: "PRICING_TABLE_SELECTED_ITEMS_ADD_ITEM" as const,
    PRICING_TABLE_SELECTED_ITEMS_REMOVE_ITEM: "PRICING_TABLE_SELECTED_ITEMS_REMOVE_ITEM" as const,
    SET_PRICING_TABLE_ITEMS: "SET_PRICING_TABLE_ITEMS" as const,
    SET_PRICING_TABLE_GROUPS: "SET_PRICING_TABLE_GROUPS" as const,
    SET_PRICING_TABLE_GROUP: "SET_PRICING_TABLE_GROUP" as const,
    DELETE_PRICING_TABLE_GROUP: "DELETE_PRICING_TABLE_GROUP" as const,
    SET_PRICING_TABLE_ITEM: "SET_PRICING_TABLE_ITEM" as const,
    PRICING_TABLE_SET_SELECTED_ITEMS: "PRICING_TABLE_SET_SELECTED_ITEMS" as const,
    PRICING_TABLE_BOTTOM_PRICE_ENABLED: "PRICING_TABLE_BOTTOM_PRICE_ENABLED" as const,
    ADD_MULTI_ITEMS_FROM_REFERENCE: "ADD_MULTI_ITEMS_FROM_REFERENCE" as const,
    ADD_MULTI_ITEMS_FROM_REFERENCE_SUCCESS: "ADD_MULTI_ITEMS_FROM_REFERENCE_SUCCESS" as const,
    IS_WORKFLOW_LOADING: "IS_WORKFLOW_LOADING" as const,
    BULK_PATCH_PRICING_TABLE: "BULK_PATCH_PRICING_TABLE" as const,
}

export type Actions =
    | { type: typeof ACTION_TYPES.SET_INITIAL_VALUES }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_ID,
        payload: { pricingTableId: string, objectId: string } }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE, payload: InvoiceDto }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_TOTALS,
        payload: { objectId: string, totals: PricingTotalDto[] } }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_TAXES,
        payload: { objectId: string, taxes: Map<string, TaxDto> } }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_GROUP_ITEMS,
        payload: { objectId: string, groupId: string, groupItems: string[] } }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_FEES,
        payload: { objectId: string, fees: PricingFeeCalculationDto[] | undefined } }
    | { type: typeof ACTION_TYPES.PRICING_TABLE_SELECTED_ITEMS_ADD_ITEM,
        payload: { objectId: string, item: string } }
    | { type: typeof ACTION_TYPES.PRICING_TABLE_SELECTED_ITEMS_REMOVE_ITEM,
        payload: { objectId: string, item: string } }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_ITEMS,
        payload: { pricingTableObjectId: string, pricingTableItems: PricingRowDto[] } }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_GROUPS,
        payload: { pricingTableObjectId: string, pricingTableGroups: GroupDto[] } }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_GROUP,
        payload: { groupId: string, objectId: string, group: GroupDto } }
    | { type: typeof ACTION_TYPES.SET_PRICING_TABLE_ITEM,
        payload: { itemId: string, objectId: string, item: PricingRowDto } }
    | { type: typeof ACTION_TYPES.PRICING_TABLE_SET_SELECTED_ITEMS,
        payload: { objectId: string, items: Set<string> } }
    | { type: typeof ACTION_TYPES.PRICING_TABLE_BOTTOM_PRICE_ENABLED,
        payload: { quoteId: string, isBottomPriceEnabled: boolean } }
    | { type: typeof ACTION_TYPES.IS_WORKFLOW_LOADING,
        payload: boolean }
    | { type: typeof ACTION_TYPES.PATCH_PRICING_TABLE_ITEM,
        payload: {
            id:string,
            objectId: string,
            documentType: string,
            itemUpdatePayload : PatchRowPayload,
            updateGroup: boolean,
            updateTotals: boolean
        }}
    | { type: typeof ACTION_TYPES.PATCH_PRICING_TABLE_ITEM_SUCCESS,
        payload: {
            item : PricingRow,
            id : string,
            objectId : string,
            updateGroup: boolean,
            updateTotals : boolean
        }}
        | { type: typeof ACTION_TYPES.DELETE_PRICING_TABLE_ITEM,
            payload: {
                id:string,
                objectId: string,
                documentType: string
            }}
            | { type: typeof ACTION_TYPES.DELETE_PRICING_TABLE_ITEM_SUCCESS,
                payload: {
                    itemId: string,
                    item : PricingRow,
                    objectId: string
                }}

    | { type: typeof ACTION_TYPES.PATCH_PRICING_TABLE, payload: {
        documentType: DOCUMENT_TYPE,
        documentId: string,
        payload: PatchPayload } }
    | { type: typeof ACTION_TYPES.PATCH_PRICING_TABLE_SUCCESS, payload: InvoiceDto | QuoteDto | OrderDto | PricingTable }
    | { type: typeof ACTION_TYPES.PATCH_PRICING_TABLE_PENDING }
    | { type: typeof ACTION_TYPES.CREATE_GROUP, payload: CreateGroupPayload }
    | { type: typeof ACTION_TYPES.CREATE_PRICING_TABLE_GROUP_SUCCESS, payload: GroupDto }
    | { type: typeof ACTION_TYPES.ADD_MULTI_ITEMS_FROM_REFERENCE, payload: RowReferencePayload}
    | { type: typeof ACTION_TYPES.BULK_PATCH_PRICING_TABLE, payload: {
        documentType: DOCUMENT_TYPE,
        documentId: string,
        payload: PatchPayload } }


// WEBPACK FOOTER //
// ./src/state/pricing/actions/types.ts